import React, { Component } from 'react';
import { Button, Row } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { urls } from '../../services/Server';
import './Login.css';

export default class Login extends Component {
  /*
    This component shows login possibilities.
  */

  static loginWithFacebook() {
    window.location.href = urls.facebookAuth;
  }

  static loginWithGoogle() {
    window.location.href = urls.googleAuth;
  }

  render() {
    const self = Login;
    return (
      <Row>
        <div className="login-wrapper">
          <Button variant="light" onClick={self.loginWithFacebook}>
            <FontAwesome name="facebook-square" />
            <span>Logg inn med Facebook</span>
          </Button>
          <Button variant="light" onClick={self.loginWithGoogle}>
            <FontAwesome name="google" />
            <span>Logg inn med Google</span>
          </Button>
          <form method="post" action={urls.testUserAuth}>
            <input hidden readOnly name="username" value="test" />
            <input hidden readOnly name="password" value="user" />
            <Button variant="light" type="submit">
              <FontAwesome name="user-secret" />
              <span>Logg inn med testbruker</span>
            </Button>
          </form>
        </div>
      </Row>
    );
  }
}
